var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5265 0.120209C13.2764 0.00225222 12.6762 -0.0775238 12.4409 0.120255L5.77664 5.73523H2.43702C1.64522 5.73523 1 6.37334 1 7.1564V12.8411C1 13.6255 1.64522 14.2622 2.43702 14.2622H5.77664L12.4409 19.9468C12.5716 20.0492 13.2105 19.9723 13.2105 19.9723C13.2105 19.9723 13.4273 19.9227 13.5265 19.8758C13.7751 19.7579 13.9331 19.5092 13.9331 19.2363V0.761154C13.9331 0.488291 13.7751 0.239587 13.5265 0.120209Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1033 4.97402C16.8234 4.69831 16.3743 4.70258 16.0986 4.9797C15.8229 5.25967 15.8257 5.70876 16.1043 5.98589C17.1786 7.04608 17.7698 8.47151 17.7698 9.99926C17.7698 11.527 17.1786 12.9524 16.1043 14.0126C15.8257 14.2869 15.8229 14.7374 16.0986 15.0174C16.2378 15.1581 16.4212 15.2277 16.6031 15.2277C16.7836 15.2277 16.9641 15.1595 17.1033 15.0217C18.4506 13.6957 19.191 11.9107 19.191 9.99926C19.191 8.08779 18.4506 6.30281 17.1033 4.97402Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMute);
export default __webpack_public_path__ + "static/media/icon-mute.bab9dddae2f36cf58aa9d49002967fbd.svg";
export { ForwardRef as ReactComponent };